var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7501 15.8582H8.69031L7.14576 9.79237C7.07245 9.51334 6.91679 9.26667 6.68782 9.1504C6.11639 8.85823 5.48672 8.62571 4.7998 8.50843V8.2749H8.11789C8.57583 8.2749 8.91929 8.62571 8.97653 9.03313L9.77793 13.4086L11.8367 8.2749H13.8392L10.7501 15.8582ZM14.984 15.8582H13.0388L14.6406 8.2749H16.5858L14.984 15.8582ZM19.1025 10.3757C19.1597 9.96728 19.5032 9.73374 19.9039 9.73374C20.5336 9.67511 21.2195 9.79238 21.7919 10.0835L22.1354 8.45081C21.5629 8.21727 20.9333 8.1 20.3619 8.1C18.4738 8.1 17.1 9.15041 17.1 10.6082C17.1 11.7173 18.0731 12.2996 18.7601 12.6504C19.5032 13.0002 19.7894 13.2338 19.7322 13.5835C19.7322 14.1082 19.1597 14.3418 18.5883 14.3418C17.9014 14.3418 17.2145 14.1669 16.5858 13.8747L16.2424 15.5085C16.9293 15.7996 17.6724 15.9169 18.3594 15.9169C20.4763 15.9745 21.7919 14.9251 21.7919 13.35C21.7919 11.3665 19.1025 11.2502 19.1025 10.3757ZM28.5998 15.8582L27.0553 8.2749H25.3962C25.0528 8.2749 24.7093 8.50843 24.5948 8.85823L21.7347 15.8582H23.7372L24.1369 14.7502H26.5973L26.8263 15.8582H28.5998ZM25.6824 10.3171L26.2539 13.1751H24.6521L25.6824 10.3171Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.980a3e0082bb473e20f4a423df1925fd.svg";
export { ForwardRef as ReactComponent };